import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const theme: ThemeApp['appComponents']['viewCrdb'] = {
  components: {
    regionDetails: {
      regionLocation: {
        color: themeUi.semantic.color.text.neutral800
      }
    },

    crdbConfiguration: {
      components: {
        dangerZoneSection: {
          dangerZoneCard: {
            borderBottom: themeUi.semantic.color.border.neutral400
          }
        },

        generalSection: {
          components: {
            crdbName: {
              color: themeUi.semantic.color.text.neutral800
            },
            crdbNameAndPort: {
              divider: {
                backgroundColor: themeUi.semantic.color.background.neutral400
              }
            },
            globalDetails: {
              labelsContainer: {
                color: themeUi.semantic.color.text.neutral800
              },
              divider: {
                backgroundColor: themeUi.semantic.color.background.neutral400
              }
            }
          }
        },

        internalSettingsSection: {
          components: {
            crdbCompression: {
              Description: {
                color: themeUi.semantic.color.text.neutral600
              }
            }
          }
        },

        overridingRegionsInfo: {
          title: {
            color: themeUi.semantic.color.text.neutral800
          }
        },

        overrideGlobalCheckbox: {
          container: {
            color: themeUi.semantic.color.text.neutral800
          }
        },

        scalabilitySection: {
          components: {
            instanceThroughput: {
              throughputLabel: {
                color: themeUi.semantic.color.text.neutral800
              },
              components: {
                throughputItem: {
                  opsPerSecText: {
                    color: themeUi.semantic.color.text.neutral600
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

export default theme;
